import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on pathname change unless the change is a language switch
export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (state && state.langSwitch) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, state]);

  return null;
}
